import { pathBuilder } from 'config/paths/index';

export const root = '/admin/company/eligibilities';
export default pathBuilder(root);
